export default "__VITE_ASSET__CPZw_mCa__"